import Swiper, { Navigation } from 'swiper';

const initJourneySwiper = (scope = document) => {
  const wrappers = scope.querySelectorAll('.journey-swiper-wr');

  wrappers.forEach((wrapper) => {
    const swiperEl = wrapper.querySelector('.swiper');

    if (!swiperEl || swiperEl.swiper) {
      return;
    }

    const nextEl = wrapper.querySelector('.swiper-button-next');
    const prevEl = wrapper.querySelector('.swiper-button-prev');

    new Swiper(swiperEl, {
      modules: [Navigation],
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      speed: 500,
      threshold: 10,
      watchOverflow: true,
      navigation: nextEl && prevEl ? {
        nextEl,
        prevEl,
      } : undefined,
      breakpoints: {
        375: {
          slidesPerView: 2,
          spaceBetween: 44,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 52,
        },
        951: {
          slidesPerView: 4,
          spaceBetween: 48,
        },
        1023: {
          slidesPerView: 5,
          spaceBetween: 56,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 64,
        },
        1440: {
          slidesPerView: 5,
          spaceBetween: 72,
        },
      },
    });
  });
};

initJourneySwiper();
window.initJourneySwiper = initJourneySwiper;
